import dynamic from 'next/dynamic'

export const MultiCopySection = dynamic(() => import('./multi-copy-section'))
